
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("iyrx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $33bd1ba62b7a4b23$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $kV9ss = parcelRequire("kV9ss");

var $b32lf = parcelRequire("b32lf");

var $jiRmc = parcelRequire("jiRmc");

var $jFysZ = parcelRequire("jFysZ");

const $33bd1ba62b7a4b23$var$LOG_LOCATION = 'jira-realtime';
// eslint-disable-next-line jira/react/no-class-components
class $33bd1ba62b7a4b23$var$RealtimeOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels, onReceive: onReceive } = this.props;
        if ((0, $4R6GH.fg)('jirt-log-unsupported-channels')) this.logUnsupportedChannels(channels, appId);
        if ((0, $4R6GH.fg)('jirt-use-graphql-subscriptions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFysZ.RealtimeSubscriptions), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels,
            events: events,
            onReceive: onReceive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
            appId: appId,
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args), this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        }, this.logUnsupportedChannels = (channels, appId)=>{
            const unsupportedChannels = channels.filter((channel)=>!(0, $kV9ss.JiraProjectAri).check(channel));
            if (unsupportedChannels.length > 0) (0, $2YZCu.default).safeWarnWithoutCustomerData($33bd1ba62b7a4b23$var$LOG_LOCATION, 'Unsupported channels', {
                source: (0, $4R6GH.fg)('jirt-use-graphql-subscriptions') ? (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df) : (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: appId,
                unsupportedChannels: unsupportedChannels?.join(', ')
            });
        };
    }
}
var $33bd1ba62b7a4b23$export$2e2bcd8739ae039 = $33bd1ba62b7a4b23$var$RealtimeOld;

});
parcelRegister("kV9ss", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAri", () => $f3b077b345ad4318$export$75a0a0a7cb0a58ae);

var $FYyiD = parcelRequire("FYyiD");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/project/manifest.ts
var $f3b077b345ad4318$var$jiraProjectAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $FYyiD.JiraProjectAriResourceOwner),
    resourceType: (0, $FYyiD.JiraProjectAriResourceType),
    resourceIdSlug: "{projectId}",
    resourceIdSegmentFormats: {
        projectId: /[0-9]+/
    }
};
// src/jira/project/index.ts
var $f3b077b345ad4318$export$75a0a0a7cb0a58ae = class _JiraProjectAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._projectId = opts.resourceIdSegmentValues.projectId;
    }
    get siteId() {
        return this._siteId;
    }
    get projectId() {
        return this._projectId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.qualifier,
            platformQualifier: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.resourceOwner,
            resourceType: $f3b077b345ad4318$var$jiraProjectAriStaticOpts.resourceType,
            resourceId: `${opts.projectId}`,
            resourceIdSegmentValues: {
                projectId: opts.projectId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $f3b077b345ad4318$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $f3b077b345ad4318$var$jiraProjectAriStaticOpts);
        return new _JiraProjectAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            projectId: this.projectId
        };
    }
};

});
parcelRegister("FYyiD", function(module, exports) {

$parcel$export(module.exports, "JiraProjectAriResourceOwner", () => $07e2ccdc15c7364e$export$99d538a3b04916b1);
$parcel$export(module.exports, "JiraProjectAriResourceType", () => $07e2ccdc15c7364e$export$736763838d3aa22e);
// src/jira/project/types.ts
var $07e2ccdc15c7364e$export$99d538a3b04916b1 = "jira", $07e2ccdc15c7364e$export$736763838d3aa22e = "project";

});


parcelRegister("b32lf", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $89de761bbc8dc49a$export$e680ceb7b9fcc184);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");


var $kc9rs = parcelRequire("kc9rs");

var $50Ssb = parcelRequire("50Ssb");

var $iwG6l = parcelRequire("iwG6l");
const $89de761bbc8dc49a$var$LOG_LOCATION = 'jira-realtime-client-fps';
// eslint-disable-next-line jira/react/no-class-components
class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.onReceiveEvent = (event, payload)=>{
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) {
                if (!(0, $4R6GH.fg)('jirt-disable-even-received-analytic-event')) (0, $kc9rs.applyOneInThousandSample)(()=>(0, $2YZCu.default).safeInfoWithoutCustomerData($89de761bbc8dc49a$var$LOG_LOCATION, 'Event received', {
                        source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                        appId: this.props?.appId,
                        eventType: String(event)
                    }));
            }
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        }, this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        }, this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        }, this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        }, this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $89de761bbc8dc49a$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeClient', {
    onReceive: 'eventReceived'
});
const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, $iwG6l.withPubSubClient), (0, $50Ssb.asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;

});
const $cd8288ab589b4c19$export$4854d3ddf830ca94 = 'fps';
const $cd8288ab589b4c19$export$f7ec9b25c28de3df = 'subscriptions';

parcelRegister("kc9rs", function(module, exports) {

$parcel$export(module.exports, "applyOneInThousandSample", () => $10dcad6095a594a9$export$d1307c59a467cc9d);
const $10dcad6095a594a9$export$51faa5b20b5ba129 = 0.1;
const $10dcad6095a594a9$export$d08a672098aef6e1 = 0.001;
function $10dcad6095a594a9$export$a2f2c353b604e9f8(callback, options = {}) {
    if (Math.random() < (options.sampleRate ?? $10dcad6095a594a9$export$51faa5b20b5ba129)) callback();
}
function $10dcad6095a594a9$export$d1307c59a467cc9d(callback) {
    $10dcad6095a594a9$export$a2f2c353b604e9f8(callback, {
        sampleRate: $10dcad6095a594a9$export$d08a672098aef6e1
    });
}

});

parcelRegister("50Ssb", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $ccf1df230f4f0e4b$export$95cd02374de3431);

var $5uXOq = parcelRequire("5uXOq");
function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;

});

parcelRegister("iwG6l", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $9fb4f4e8a5d3670b$export$32d968d4900ae3cd);

var $5uXOq = parcelRequire("5uXOq");

var $bYYrF = parcelRequire("bYYrF");
function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;

});
parcelRegister("bYYrF", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $9398e66c20b16e31$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $9398e66c20b16e31$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
const $9398e66c20b16e31$var$defaultContext = {
    client: null
};
const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);

});



parcelRegister("jiRmc", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $db014a952af56f77$export$64d242981d970821);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $2OMDV = parcelRequire("2OMDV");

var $fjcgS = parcelRequire("fjcgS");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");


var $bYYrF = parcelRequire("bYYrF");


var $1eGpy = parcelRequire("1eGpy");

var $FPIEb = parcelRequire("FPIEb");
const $db014a952af56f77$var$LOG_LOCATION = 'jira-realtime-provider-fps';

const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("dVpZZ")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler, onError)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) {
            // ignore HTTP client errors and client fetch errors
            if ((0, $fZneA.isHttpClientErrorResponse)(error) || (0, $fZneA.isClientFetchError)(error) || error && error.code === 401) return;
        } else {
            // Ideally anonymous users shouldn't get there.
            // Ignoring 401 status codes until it is fixed on the app level.
            // eslint-disable-next-line no-lonely-if
            if (error && error.code === 401) return;
        }
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to join channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler, onError)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to left channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels, onError: onError } = this.props;
        this.isComponentMounted = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel, onError).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels, onError: onError } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) {
                if (removedChannels.length > 0) {
                    $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                    $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
                }
            } else {
                $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
            }
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels, onError: onError } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel, onError);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            client: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            const joinChannels = result?.channels?.length > 0 ? result?.channels : this.props.channels;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Joined channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: joinChannels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(joinChannels ?? []));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            const leaveChannels = result?.channels?.length > 0 ? result?.channels : this.props.channels;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Left channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: leaveChannels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(leaveChannels ?? []));
        }, this.isComponentMounted = false;
    }
}
const $db014a952af56f77$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)('realtimeProvider', {
    onJoin: 'joinedChannel',
    onLeave: 'leftChannel'
});
const $db014a952af56f77$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, $1eGpy.withHost), (0, $FPIEb.withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;

});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("1eGpy", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $af5e53f160713d44$export$b2d89aaea1461cd9);

var $5uXOq = parcelRequire("5uXOq");

var $4h0Jz = parcelRequire("4h0Jz");
function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            host: (0, $4h0Jz.getDefaultPubSubHost)()
        });
}
var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;

});
parcelRegister("4h0Jz", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $15272668181566a5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $15272668181566a5$export$354e43de513ff5);

var $j8DrX = parcelRequire("j8DrX");

const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, $j8DrX.default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("FPIEb", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $5962bf1fe62742cb$export$4b38d0b01368c3f4);

var $5uXOq = parcelRequire("5uXOq");
function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;

});

parcelRegister("dVpZZ", function(module, exports) {

let $a234c40e246e9957$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a234c40e246e9957$var$load("kpnGY").then(()=>parcelRequire('9uh43'));

});


parcelRegister("jFysZ", function(module, exports) {

$parcel$export(module.exports, "RealtimeSubscriptions", () => $03883409ac785040$export$ecba46e7f0609959);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $kV9ss = parcelRequire("kV9ss");

var $hMvRp = parcelRequire("hMvRp");

var $90yGq = parcelRequire("90yGq");

var $4R6GH = parcelRequire("4R6GH");


var $cnhn5 = parcelRequire("cnhn5");

var $43Yto = parcelRequire("43Yto");

var $kc9rs = parcelRequire("kc9rs");

var $4w2WY = parcelRequire("4w2WY");

var $1H73m = parcelRequire("1H73m");
const $03883409ac785040$var$getProjectIdsToSubscribe = (channels)=>channels?.filter((projectAri)=>(0, $kV9ss.JiraProjectAri).check(projectAri))?.map((projectAri)=>(0, $kV9ss.JiraProjectAri).parse(projectAri))?.map((data)=>data.projectId)?.filter(Boolean) ?? [];
const $03883409ac785040$var$getIssueEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$var$getBoardEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$export$ecba46e7f0609959 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { appId: appId, channels: channels, events: events, onJoin: onJoin, onReceive: onReceive, onLeave: onLeave } = props;
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const projectIds = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getProjectIdsToSubscribe(channels), [
        channels
    ]);
    const issueEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getIssueEventToSubscribe(events), [
        events
    ]);
    const boardEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getBoardEventToSubscribe(events), [
        events
    ]);
    const handleOnJoin = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).SUBSCRIPTION_STARTED}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            appId: appId,
            channels: channels
        });
        onJoin(channels);
    }, [
        createAnalyticsEvent,
        appId,
        channels,
        onJoin
    ]);
    const handleOnReceive = (0, $5uXOq.useCallback)((event)=>{
        const { type: type, payload: { atlassianId: atlassianId } } = event;
        if (!(0, $4R6GH.fg)('jirt-disable-even-received-analytic-event')) (0, $kc9rs.applyOneInThousandSample)(()=>(0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).EVENT_RECEIVED}`, {
                source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
                eventType: type,
                appId: appId,
                channels: channels,
                isTriggeredBySameUser: atlassianId === atlassianAccountId
            }));
        onReceive(event);
    }, [
        appId,
        atlassianAccountId,
        channels,
        createAnalyticsEvent,
        onReceive
    ]);
    const handleOnLeave = (0, $5uXOq.useCallback)(()=>{
        onLeave(channels);
    }, [
        channels,
        onLeave
    ]);
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).FAILURE}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            appId: appId,
            channels: channels,
            events: issueEvents,
            error: error.message
        });
    }, [
        channels,
        appId,
        issueEvents,
        createAnalyticsEvent
    ]);
    const shouldRenderIssueSubscription = projectIds?.length > 0 && issueEvents?.length > 0;
    const shouldRenderBoardIssueSubscription = projectIds?.length > 0 && boardEvents?.length > 0;
    // Do not render the component on server-side
    // rendering to avoid hydration issues
    if (false && (0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) return null;
    // Do not render the component when the page or tab is not visible
    // this will force the subscription components to unsubscribe
    // and avoid unnecessary data transfer when the user is not visualizing
    // the page. The subscription will be re-established when the page
    // or tab is visible again.
    if (!isVisible && !(0, $4R6GH.fg)('jirt-disable-resubscription-for-page-visibility')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldRenderIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w2WY.IssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: issueEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }), shouldRenderBoardIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1H73m.BoardIssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: boardEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }));
});

});
parcelRegister("hMvRp", function(module, exports) {

$parcel$export(module.exports, "usePageVisibility", () => $124c6a08c4f63b4e$export$6c98eb2f12f4ec61);

var $5uXOq = parcelRequire("5uXOq");

var $laTox = parcelRequire("laTox");
const $124c6a08c4f63b4e$export$6c98eb2f12f4ec61 = ()=>{
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)((0, $laTox.isPageVisible)());
    (0, $5uXOq.useEffect)(()=>{
        const onVisibilityChange = ()=>setIsVisible((0, $laTox.isPageVisible)());
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', onVisibilityChange);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);
    return isVisible;
};

});
parcelRegister("laTox", function(module, exports) {

$parcel$export(module.exports, "supportedVisiblityEvent", () => $845c75a1dcb2afb9$export$f7132cb36c80dad);
$parcel$export(module.exports, "isPageVisible", () => $845c75a1dcb2afb9$export$ae4f9b990bc70f70);
const $845c75a1dcb2afb9$var$visibilityMap = {
    // document property: event name
    hidden: 'visibilitychange',
    mozHidden: 'mozvisibilitychange',
    msHidden: 'msvisibilitychange',
    webkitHidden: 'webkitvisibilitychange'
};
const $845c75a1dcb2afb9$var$supportedHiddenKey = Object.keys($845c75a1dcb2afb9$var$visibilityMap).find(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Document'.
(key)=>typeof document !== 'undefined' && typeof document[key] !== 'undefined');
const $845c75a1dcb2afb9$export$f7132cb36c80dad = $845c75a1dcb2afb9$var$visibilityMap[$845c75a1dcb2afb9$var$supportedHiddenKey];
const $845c75a1dcb2afb9$export$ae4f9b990bc70f70 = ()=>typeof document !== 'undefined' && !document[$845c75a1dcb2afb9$var$supportedHiddenKey];

});


parcelRegister("43Yto", function(module, exports) {

$parcel$export(module.exports, "analyticsComponent", () => $e9d4cd49d7351075$export$b6860299007c6993);
$parcel$export(module.exports, "analyticEvents", () => $e9d4cd49d7351075$export$959fab53eba8917d);
const $e9d4cd49d7351075$export$b6860299007c6993 = 'jiraRealtime';
const $e9d4cd49d7351075$export$959fab53eba8917d = {
    SUBSCRIPTION_STARTED: 'subscriptionStarted',
    EVENT_RECEIVED: 'eventReceived',
    FAILURE: 'errorReceived',
    JOINED_CHANNEL: 'joinedChannel',
    LEFT_CHANNEL: 'leftChannel'
};

});

parcelRegister("4w2WY", function(module, exports) {

$parcel$export(module.exports, "IssueSubscription", () => $77e279b1082e054b$export$97b721965fbe4764);

var $hBgv0 = parcelRequire("hBgv0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $jUlV7 = parcelRequire("jUlV7");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $bkbBi = parcelRequire("bkbBi");


var $kc9rs = parcelRequire("kc9rs");
const $77e279b1082e054b$var$LOG_LOCATION = 'jira-realtime-issue-subscription';
const $77e279b1082e054b$export$97b721965fbe4764 = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $hBgv0.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isSubscriptionEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const issueId = Number((0, $jUlV7.JiraIssueAri).parse(payload.resource).issueId);
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        atlassianId: String(payload.actionerAccountId),
                        projectId: payload.project?.id,
                        issueId: issueId
                    }
                };
                if (!(0, $4R6GH.fg)('jirt-disable-even-received-analytic-event')) (0, $kc9rs.applyOneInThousandSample)(()=>(0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Event received', {
                        ...defaultAttributes,
                        eventType: payload.type,
                        projectId: payload.project?.id,
                        issueId: issueId,
                        resource: payload.resource,
                        triggeredBy: String(payload.actionerAccountId),
                        receivedBy: atlassianAccountId,
                        isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                    }));
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                if ((0, $fZneA.isHttpClientErrorResponse)(error) || (0, $fZneA.isClientFetchError)(error)) // Ignore HTTP client errors or fetch errors, as they are expected in some cases.
                return;
                (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("hBgv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd668aee84be2330$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<328c09410a7466f00f74849cd5dfcec8>>
 * @relayHash 92106690bb7e678270694af845fb5480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068
const $dd668aee84be2330$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "actionerAccountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "concreteType": "JiraIssueStreamHubEventPayloadProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068",
            "metadata": {},
            "name": "IssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$dd668aee84be2330$var$node.hash = "1288b7ac81835d68c9265e8c3bdfa3d5";
var $dd668aee84be2330$export$2e2bcd8739ae039 = $dd668aee84be2330$var$node;

});

parcelRegister("jUlV7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $e7e440357f375b75$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $3NoER = parcelRequire("3NoER");

var $gYPG7 = parcelRequire("gYPG7");
// src/jira/issue/manifest.ts
var $e7e440357f375b75$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $e7e440357f375b75$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $3NoER.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $e7e440357f375b75$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $e7e440357f375b75$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $gYPG7.AriParser).fromOpts(derivedOpts, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $gYPG7.AriParser).fromString(maybeAri, $e7e440357f375b75$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("bkbBi", function(module, exports) {

$parcel$export(module.exports, "isSubscriptionEventType", () => $461958717eae170a$export$cec76ac77e3d331);
$parcel$export(module.exports, "isBoardIssueEventType", () => $461958717eae170a$export$4bc59bf28171f69e);

var $cnhn5 = parcelRequire("cnhn5");
function $461958717eae170a$export$cec76ac77e3d331(type) {
    return typeof type === 'string' && (0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(type);
}
function $461958717eae170a$export$4bc59bf28171f69e(type) {
    return typeof type === 'string' && (0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(type);
}

});


parcelRegister("1H73m", function(module, exports) {

$parcel$export(module.exports, "BoardIssueSubscription", () => $70818e6682d73c66$export$20d42873ce3eb6aa);

var $jonoc = parcelRequire("jonoc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $fZneA = parcelRequire("fZneA");

var $bkbBi = parcelRequire("bkbBi");


var $kc9rs = parcelRequire("kc9rs");
const $70818e6682d73c66$var$LOG_LOCATION = 'jira-realtime-board-issue-subscription';
const $70818e6682d73c66$export$20d42873ce3eb6aa = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $jonoc.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtBoardIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isBoardIssueEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const boardId = Number(payload.boardId);
                const projectId = payload.projectId;
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        boardId: boardId,
                        projectId: projectId,
                        atlassianId: String(payload.actionerAccountId)
                    }
                };
                if (!(0, $4R6GH.fg)('jirt-disable-even-received-analytic-event')) (0, $kc9rs.applyOneInThousandSample)(()=>(0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Event received', {
                        ...defaultAttributes,
                        eventType: payload.type,
                        projectId: projectId,
                        boardId: boardId,
                        resource: payload.resource,
                        triggeredBy: String(payload.actionerAccountId),
                        receivedBy: atlassianAccountId,
                        isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                    }));
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                if ((0, $fZneA.isHttpClientErrorResponse)(error) || (0, $fZneA.isClientFetchError)(error)) // Ignore HTTP client errors or fetch errors, as they are expected in some cases.
                return;
                (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("jonoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e7cd29e30a9cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<730097d6ae65b73af54d4da2e8d8c906>>
 * @relayHash 7ea059724811cea589537e314b11add7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a
const $d72e7cd29e30a9cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtBoardScoreIssueEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtBoardIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "cloudId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a",
            "metadata": {},
            "name": "BoardIssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$d72e7cd29e30a9cc$var$node.hash = "fe89207b97768c1d05529ecc19effa77";
var $d72e7cd29e30a9cc$export$2e2bcd8739ae039 = $d72e7cd29e30a9cc$var$node;

});





$parcel$global.rlb("kLeYK")
//# sourceMappingURL=main-old.15aa2397.js.map
